import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from "@angular/core";

declare let gtag: Function;

@Component({
  selector: "app-info360-container",
  templateUrl: "./info360-container.component.html",
  styleUrls: ["./info360-container.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class Info360ContainerComponent {
  @Input() item;
  @Input() client;
  public currentContent = "information";
  @Output() close: EventEmitter<string> = new EventEmitter();

  constructor() {}

  public changeContent(content: string) {
    gtag("event", `${this.client.name}_change_tab`, {
      tab: content,
    });
    this.currentContent = content;
  }

  closeMe() {
    this.close.emit();
  }
}
